import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer-container">
      <section className="social-media">
        <div className="social-media-wrap">
          <div className="footer-logo">
            <Link to="/" className="social-logo">
              <img
                src="/images/lunde-water-logo.png"
                alt="Lunde Water, LLC"
                className="navbar-icon"
                style={{ height: 34 }}
              />
              LUNDE WATER, LLC
            </Link>
          </div>
          <small className="website-rights">
            Lunde Water, LLC © {new Date().getFullYear()}
          </small>
        </div>
      </section>
    </div>
  );
}

export default Footer;
